<script setup lang="ts">
import type { NewProduct } from '@/types/api/api-v4/product'
import type { ProductV5 } from '@/types/api/api-v5/product'
import {
  ProductParentType,
  ProductTagSize,
} from '@/types/components/product-card.types'

import ProductTag from '@/components/Product/ProductTags/ProductTag.vue'

type Props = {
  product: NewProduct | ProductV5
  type: ProductParentType
  size?: ProductTagSize
}

const props = defineProps<Props>()

const isVisible = computed(() => {
  return (
    props.product?.elements && props.product.category_slug?.includes('sety')
  )
})
</script>

<template>
  <product-tag
    v-if="isVisible"
    color="var(--ui-white)"
    background-color="rgba(var(--ui-secondary-rgb), 0.8)"
    :type="type"
    :size="size"
  >
    {{ product.elements }}&nbsp;шт.
  </product-tag>
</template>
